export const authTokenInterceptor = config => {
	const authToken = localStorage.getItem("__data");
	console.log(`token us ${authToken}`);
	if (authToken) {
		config.headers.Authorization = `Token ${authToken}`;
	}
	return config;
};
